// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.invoice-row[data-v-44fb94b3]:hover {\r\n  background-color: #edf5ff;\n}\n.active[data-v-44fb94b3] {\r\n  background-color: #edf5ff;\n}\r\n", ""]);
// Exports
module.exports = exports;
